import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Injectable } from '@angular/core';
import { MzBaseModal, MzModalComponent } from 'ngx-materialize';
import { esquemas } from 'src/app/_models/formularios/esquemas.model';
import { Plantillas } from 'src/app/_models/formularios/plantillas.model';
import { Seccion } from 'src/app/_models/formularios/seccion.model';
import { AuthenticationService } from 'src/app/_services/authentification.service';
import { REST_SERVICES } from 'src/app/_services/settings';
import { ZeroService } from 'src/app/_services/zero/zero.service';


@Component({
  selector: 'app-modaledit-seccion',
  templateUrl: './modaledit-seccion.component.html',

})
export class ModalEditSeccionComponent extends MzBaseModal {
  public seccion: Seccion;
  public esInternacional: Boolean;
  public esOtroEsquema: Boolean;
  @ViewChild('DSCSECCION') DSCSECCION: ElementRef;
  @ViewChild('POSICION') POSICION: ElementRef;
  @ViewChild('ErrorEditSeccion') ErrorEditSeccion: MzModalComponent;
  // datos de entrada por el servicio de modal
  @Input() public seccionInput1: Seccion;
  // Emitter para envío de parámetros
  @Output() updateSeccion: EventEmitter<Seccion>;

  public plantillas : Array<Plantillas>;
  public esquemas : Array<esquemas>;
  public idEsquema : String;

  public selecionoCamposInternacional : Boolean;
  public seleccionoPlantilla : Boolean;
  public seleccionoEsquema : Boolean;

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%',
  };

  constructor(private zeroService: ZeroService, 
    private authenticationService: AuthenticationService) {
    super();
    this.updateSeccion = new EventEmitter();
    this.seccion = new Seccion();
    this.plantillas = new Array<Plantillas>();
    this.esquemas = new Array<esquemas>();
    this.selecionoCamposInternacional = true;
    this.seleccionoPlantilla = true;
    this.seleccionoEsquema = true;
  }

  ngOnInit() {
    this.seccion.idAnt = this.seccionInput1.idSeccionPk;
    this.buscarPlantillas();
    this.buscarEsquemas();
    this.esInternacional = this.seccionInput1.idPlantillaFk != null;
    this.idEsquema = this.authenticationService.currentUserValue.idEsquema;
    if (this.seccionInput1.idEsquemaFk != null) {
      this.esOtroEsquema = this.idEsquema != this.seccionInput1.idEsquemaFk.toString();
    } else {
      this.esOtroEsquema = false;
    }
    this.selecionoCamposInternacional = true;
    this.seleccionoPlantilla = true;
    this.seleccionoEsquema = true;
  }

  cancelar() {
    this.modalComponent.closeModal();
  }
  
  // Aceptando el modal 
  public closeModal() {
    this.seccion.idSeccionPk = this.seccionInput1.idSeccionPk;
    this.seccion.idEsquemaFk = this.seccionInput1.idEsquemaFk;
    this.seccion.idPlantillaFk = this.seccionInput1.idPlantillaFk;
    this.seccion.esInternacional = this.esInternacional;
    this.seccion.esOtroEsquema = this.esOtroEsquema;
    this.seccion.dsc = this.seccionInput1.dsc;
    this.seccion.posicion = this.seccionInput1.posicion;
    if (this.seccion.dsc == null || this.seccion.dsc.trim().length == 0 || this.seccion.posicion == null) {
      this.ErrorEditSeccion.openModal();
    } else {
      this.updateSeccion.emit(this.seccion);
      this.modalComponent.closeModal();
    }
  }

  /**
   * Función que valida si fue seleccionado un valor de la lista de plantillas.
   */
  validaSeleccionoPlantilla() {
    if(this.seccionInput1.idPlantillaFk != null) {
      this.seleccionoPlantilla = true;
    }
    this.validaSeleccionoCamposInternacional();
  }
  /**
   * Función que valida si fue seleccionado un valor de la lista de esquemas.
   */
  validaSeleccionoEsquema(){
    if(this.seccionInput1.idEsquemaFk != null) {
      this.seleccionoEsquema = true;
    }
    this.validaSeleccionoCamposInternacional();
  }
  /**
   * Función que valida si los campos requeridos para sección internacional
   * ha sido capturados.
   */
  validaSeleccionoCamposInternacional() {
    if(this.seccionInput1.idEsquemaFk != null && this.seccionInput1.idPlantillaFk != null) {
         this.selecionoCamposInternacional = this.esInternacional;
    }
  }


  eventCambioInternacional() {
    if(!this.esInternacional) {
      this.seccionInput1.idEsquemaFk = null;
      this.seccionInput1.idPlantillaFk = null;
      // Se cambia valor para quitar texto de campo requerido      
      this.seleccionoPlantilla = true;
      this.seleccionoEsquema = true;
    } else {
      this.selecionoCamposInternacional = !this.esInternacional;
      this.seleccionoPlantilla = !this.esInternacional;
      this.seleccionoEsquema = !this.esInternacional;
    }
    
  }

  buscarPlantillas() {
    let scope = this;
    let plantilla = new Plantillas;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_PLANTILLAS,
      method: "POST",
      swhowInfo: true,
      params: plantilla,
      ok: (response) => {
        scope.plantillas = response.response;
      }
    });
  }

  buscarEsquemas(){
    let scope = this;
    let esquema = new esquemas;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_ESQUEMAS,
      method: "POST",
      swhowInfo: true,
      params: esquema,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.esquemas = response.response;
        }
      }
    });
  }

  }
